<template>
	<div>
		<p class="view_head">申报单位基本信息</p>
		<div style="display: flex;flex-wrap: wrap;">
			<labelText spanTitle="单位名称" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.company_name">
			</labelText>
			<labelText spanTitle="统一社会信用代码" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.tax_number">
			</labelText>
			<labelText spanTitle="联系部门" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.contact_dep">
			</labelText>
			<labelText spanTitle="联系人" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.contact_name">
			</labelText>
			<labelText spanTitle="手机电话" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.phone">
			</labelText>
			<labelText spanTitle="邮编" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.zip_code">
			</labelText>
			<labelText spanTitle="通讯地址" :spanWidth="spanWidth" componentWidth="520px"
				:pContent="[newform.province,newform.city,newform.address].join('')">
			</labelText>
		</div>
		<p class="view_head">QC小组信息</p>
		<div style="display: flex;flex-wrap: wrap;">
			<labelText spanTitle="小组名称" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.group_name">
			</labelText>
			<labelText spanTitle="小组人数" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.group_person">
			</labelText>
			<labelText spanTitle="课题名称" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.achievement_name">
			</labelText>
			<labelText spanTitle="课题类型" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.achievement_type">
			</labelText>
			<labelText spanTitle="小组活动指导者姓名" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.instructor_name">
			</labelText>
<!--			<labelText spanTitle="是否需发表" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.is_publish">
			</labelText>-->
			<labelText spanTitle="小组参与人员" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.main_member">
			</labelText>
			<labelText spanTitle="发表人姓名" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.publish_name">
			</labelText>
			<div style="width: 540px;"></div>

			<labelText spanTitle="发表人电话" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.publish_phone">
			</labelText>
			<labelText spanTitle="指导人资格证书编号" :spanWidth="spanWidth" componentWidth="520px"
				:pContent="newform.completion_certificate">
			</labelText>
			<labelText spanTitle="证书发证机构" :spanWidth="spanWidth" componentWidth="520px" :pContent="newform.issue_unit">
			</labelText>
			<labelText style="min-height: 40px;" spanTitle="小组简介" :spanWidth="spanWidth" componentWidth="1020px" :pContent="newform.group_desp">
			</labelText>
			<labelText spanTitle="主要活动过程及效果" :spanWidth="spanWidth" componentWidth="1020px" :pContent="newform.activity">
			</labelText>
		</div>
	</div>
</template>

<script>
	import labelText from '../../../components/table/labelText.vue'
	export default {
		data() {
			return {
				watchShow: false,
				newform: {},
				spanWidth: '150px',
			}
		},
		components: {
			labelText,
		},
		mounted() {
			setTimeout(() => {
				if (!this.watchShow) {
					this.newform = {
						...this.datas
					}
					// 课题类型
					if (this.newform.achievement_type == '1') {
						this.newform.achievement_type = '创新型'
					} else if (this.newform.achievement_type == '2') {
						this.newform.achievement_type = '问题解决型'
					}
					// 是否需发表
					/*if (this.newform.is_publish == '1') {
						this.newform.is_publish = '是'
					} else if (this.newform.is_publish == '2') {
						this.newform.is_publish = '否'
					}*/
				}
			}, 1000)
		},
		props: {
			datas: {
				type: Object,
				default: () => {}
			}
		},
		watch: {
			datas(newValue) {
				console.log('newValue',newValue)
				if (newValue) {
					this.watchShow = true
					// 课题类型
					if (newValue.achievement_type == '1') {
						newValue.achievement_type = '创新型'
					} else if (newValue.achievement_type == '2') {
						newValue.achievement_type = '问题解决型'
					}
					// 是否需发表
					/*if (newValue.is_publish == '1') {
						newValue.is_publish = '是'
					} else if (newValue.is_publish == '2') {
						newValue.is_publish = '否'
					}*/
					setTimeout(() => {
						this.newform = {
							...newValue
						}
					})
				}
			}
		},
	}
</script>

<style scoped>
	.view_head {
		font-size: 18px;
		font-weight: bold;
		margin-top: 20px;
	}

	.qc_list {
		display: flex;
		align-items: center;
		margin: 10px;
	}

	.qc_clumView {
		display: flex;
		flex-flow: column;
		margin: 10px;
		/* padding-left: 80px; */
		/* padding-left: 170px; */
	}

	.qc_newAdd {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 92%;
		margin-bottom: 10px;
	}

	.qc_clumView p {
		text-align: left;
		font-size: 14px;
		display: inline-block;
		margin-bottom: 10px;
	}

	.qc_clumView_right {
		width: 92%;
	}

	.qc_list__Right {
		padding-left: 20px;
	}

	.qc_list p {
		font-size: 14px;
		width: 150px;
		text-align: right;
		display: inline-block;
	}
</style>
